import React from 'react';

const LoadingState = ({ message = 'Loading data...', minHeight = '240px', className = '' }) => {
  return (
    <div 
      className={`hs-loading-state ${className}`}
      style={{ minHeight }}
      role="status"
      aria-live="polite"
    >
      <div className="spinner-border text-primary" role="status" style={{ width: '2rem', height: '2rem' }}>
        <span className="visually-hidden">Loading...</span>
      </div>
      <p className="mb-0 text-sm">{message}</p>
    </div>
  );
};

export default LoadingState;
